import React, { useEffect, useState } from 'react';
import webtonicLogo from "../components/Images/tonichub-dark.png";
import {CDBSidebar, CDBSidebarHeader} from "cdbreact";
import {ToastContainer} from "react-toastify";
import {getCompanyLogoByJobHashCode, getDocumentFile} from "../utilities/cvAPI";

const PublicLayout = ({ children, hashCode }) => {
    const [width, setWidth] = useState(window.innerWidth);
    const [companyLogo, setCompanyLogo] = useState(null);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const fetchCompanyLogo = async () => {
            try {
                const logoData = await getCompanyLogoByJobHashCode(hashCode);
                if (logoData) {
                    const s3FileName = logoData.s3FileName;
                    const logoFile = await getDocumentFile(s3FileName);
                    const logoUrl = URL.createObjectURL(logoFile);
                    setCompanyLogo(logoUrl);
                } else {
                    setCompanyLogo(webtonicLogo);
                }
            } catch (error) {
                console.error('Failed to fetch company logo:', error);
                setCompanyLogo(webtonicLogo);
            }
        };

        if (hashCode) {
            fetchCompanyLogo();
        }
    }, [hashCode]);

    const isMobile = width <= 480;

    return (
            <div data-testid={"publicDiv"} style={{backgroundColor: "#F6F6F6", padding: "5px", minHeight: "100vh"}}>
                <CDBSidebar
                    textColor="#000000" backgroundColor="#FFFFFF"
                    style={{ borderRight: "6px solid #f6f6f6", minWidth: "100%" }}
                    className={isMobile ? "d-none" : ""}
                    breakpoint={1023}>
                    <CDBSidebarHeader>
                        <ToastContainer theme="colored" />
                        <a href="/" className="text-decoration-none" style={{color:"inherit"}}>
                                {companyLogo ? <img src={companyLogo} alt="Company Logo"   style={{
                                    position: "relative",
                                    // paddingLeft: "10px",
                                    width: 220,
                                    marginLeft: "-20px"
                                }} /> : <p>Loading...</p>}
                        </a>
                    </CDBSidebarHeader>
                </CDBSidebar>
                {children}
            </div>
    )
}

export default PublicLayout;